import { render, staticRenderFns } from "./whatsapp-card.vue?vue&type=template&id=18fb0002&scoped=true&"
import script from "./whatsapp-card.vue?vue&type=script&lang=ts&"
export * from "./whatsapp-card.vue?vue&type=script&lang=ts&"
import style0 from "./whatsapp-card.vue?vue&type=style&index=0&id=18fb0002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb0002",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
